export default __webpack_public_path__ + "static/media/IF_MyTeamStrengths_Big.71826a2d.jpg";